import React from 'react';

// eslint-disable-next-line react/prop-types
const CircularInfo = () => (
  <svg
    width="14px"
    height="14px"
    viewBox="0 0 14 14"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title />
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Transactions-Refund-pop-up-01"
        transform="translate(-788.000000, -525.000000)"
        fill="#847F8D"
        fillRule="nonzero"
      >
        <g id="Group-27" transform="translate(532.000000, 213.000000)">
          <g id="Group-9" transform="translate(62.000000, 107.000000)">
            <g id="info" transform="translate(194.000000, 205.000000)">
              <path
                d="M7.36363762,2.74940564e-13 C3.70373986,2.74940564e-13 0.736842105,3.13172541 0.736842105,6.99520902 C0.736842105,10.8582336 3.70373986,13.989959 7.36363762,13.989959 C11.0235626,13.989959 13.9904875,10.8582336 13.9904875,6.99520902 C13.9904875,3.13172541 11.0235626,2.74940564e-13 7.36363762,2.74940564e-13 Z M7.36195255,2.97310656 C7.91683089,2.97310656 8.36693572,3.44804508 8.36693572,4.03392213 C8.36693572,4.61988525 7.91683089,5.09476639 7.36195255,5.09476639 C6.80685677,5.09476639 6.35672476,4.61988525 6.35672476,4.03392213 C6.35669758,3.44804508 6.80685677,2.97310656 7.36195255,2.97310656 Z M9.08833736,10.9368689 C9.08833736,11.042873 9.00691027,11.1288238 8.9066484,11.1288238 L8.32206385,11.1288238 L6.40154228,11.1288238 L5.81741976,11.1288238 C5.71715789,11.1288238 5.63578516,11.042873 5.63578516,10.9368689 L5.63578516,10.543291 C5.63578516,10.4373156 5.71713072,10.3513934 5.81741976,10.3513934 L6.40154228,10.3513934 L6.40154228,6.61861475 L5.7994547,6.61861475 C5.69919284,6.61861475 5.61776575,6.53266393 5.61776575,6.42663115 L5.61776575,6.03262295 C5.61776575,5.92661885 5.69919284,5.84069672 5.7994547,5.84069672 L6.40154228,5.84069672 L8.14045643,5.84069672 L8.14632701,5.84069672 C8.24650733,5.84069672 8.3279616,5.92661885 8.3279616,6.03262295 L8.3279616,10.3513648 L8.90667558,10.3513648 C9.00691027,10.3513648 9.08833736,10.4372869 9.08833736,10.5432623 L9.08833736,10.9368689 L9.08833736,10.9368689 Z"
                id="Shape-Copy-4"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default CircularInfo;
